import React from 'react';
import { Routes, Navigate, Route } from 'react-router-dom';
import Header from './components/Header';
import TextPage from './routes/TextPage';
import SoilAnalyses from './routes/SoilAnalyses';

export default function App() {

  return <>
    <Header/>

    <Routes>
      <Route path='/' element={<Navigate to='/soil_analyses' replace />} />

      <Route path='soil_analyses/*' element={<SoilAnalyses />} />

      <Route path='*' element={
        <TextPage>
          <h3>Error 404</h3>
          <p>La página a la que intenta acceder no existe.</p>
        </TextPage>
      } />
    </Routes>
  </>;
}